module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAZiS0dEAP8A/wD/oL2nkwAAAEpJREFUWIXtlDEOACAIxNCPE16OM8bBBW+wHVmuQ4MZ/M443PLl5i6Q7t66HhFld7auXYCAPEKQI2+AR4SAPEKQI2+AR4SAPEKABbGlEhzdisz7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/hun02.png
// module id = A9wT
// module chunks = 1